@if (filmSelectorData.filmItems.length > 1) {
  <div
    class="flex flex-row gap-16 md:gap-24 max-lg:overflow-x-auto justify-center items-center pt-4 pb-5 bg-black"
  >
    @for (
      film of filmSelectorData.filmItems;
      track trackFilm(i, film);
      let i = $index
    ) {
      <button
        class="flex flex-col items-center justify-center"
        (click)="setActiveIndex(i)"
      >
        <ss-www-image-with-loader
          class="w-40 max-md:w-24 aspect-[8/12]"
          [fileDetail]="film.image"
          [desktopImageSize]="'half'"
          [ssDirectus]="{
            collection: 'films',
            item: film.id,
            fields: ['altText'],
          }"
        ></ss-www-image-with-loader>
        <p
          class="ss-active-link text-center mt-4 max-md:mt-1 leading-5 text-[14px] max-md:text-xxs font-medium tracking-[0.8px] md:tracking-[1.12px] font-sans uppercase"
          [ssDirectus]="{
            collection: 'films',
            item: film.id,
            fields: ['title'],
          }"
          [ngClass]="{
            'ss-active-link ': currentIndex === i,
          }"
        >
          {{ film.title }}
        </p>
      </button>
    }
  </div>
}
<ss-www-building-block-outlet
  [blocks]="filmSelectorData.filmItems[currentIndex].filmBlocks"
></ss-www-building-block-outlet>
